module.exports = __webpack_public_path__ + "img/solution-preevision-function-icon-1.01632911.svg";